import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OidcRedirectComponent } from '../oidc-redirect.component';
import { IOidcLoginRequest } from '@adaptiva/data-service';
import { Observable } from 'rxjs';

@Component({
	standalone: false,
	selector: 'ada-oidc-regisrtaion-redirect',
	templateUrl: '../../oidc-landing/oidc-landing-page.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OidcRegistrationRedirectComponent extends OidcRedirectComponent {

	protected override getRedirectUrl(): string {
		return this.oidc.getRegistrationRedirectUrl();
	}
	
	protected override executeLoginTask(_loginRequest: IOidcLoginRequest): Observable<void> {
		return this.oidc.registerOidcUser(_loginRequest);
	}

}
